import { createContext, useContext, useState } from 'react';
import clientData from '../assets/demoData/clientData.json';
import clientMetrics from '../assets/demoData/clientMetrics.json';

const DemoDataContext = createContext();

export function DemoDataProvider({ children }) {
  // Demo mode is enabled by default to render demo data immediately from startup
  const [isDemoMode, setIsDemoMode] = useState(true);
  const [demoClients, setDemoClients] = useState(clientData);
  const [demoMetrics, setDemoMetrics] = useState(clientMetrics);

  const loadDemoData = async () => {
    setDemoClients(clientData);
    setDemoMetrics(clientMetrics);
    setIsDemoMode(true);
  };

  const clearDemoData = () => {
    setDemoClients([]);
    setDemoMetrics(null);
    setIsDemoMode(false);
  };

  return (
    <DemoDataContext.Provider
      value={{ demoClients, demoMetrics, isDemoMode, loadDemoData, clearDemoData }}
    >
      {children}
    </DemoDataContext.Provider>
  );
}

export function useDemoData() {
  const context = useContext(DemoDataContext);
  if (!context) {
    throw new Error('useDemoData must be used within a DemoDataProvider');
  }
  return context;
}
